/**
 * Guest-Key для НЕзарегистрированных пользователей ипотеки.
 *
 * Бэкенд (`ipoteka/core/actions/DefaultAction`): запрос к ипотеке должен нести либо
 * сессию агента (`user_id`), либо заголовок `Guest-Key`. Заявку создаёт `A4317`,
 * который сохраняет `ipoteka.guest_key = <заголовок>`; дальше `CheckAccess`
 * пускает к заявке по совпадению `guest_key` (для гостя) или `user_id` (для агента).
 *
 * Поэтому фронт шлёт `Guest-Key` на ВСЕ ипотечные запросы (через `apiFetch` и сырые
 * fetch'и). Ключ — стабильный UUID в localStorage: создаётся 1 раз и переживает
 * переходы welcome → offers → checkout → payment, иначе гость потеряет доступ к
 * только что созданной заявке. Для залогиненного агента заголовок безвреден —
 * `CheckAccess` отдаёт приоритет `user_id`.
 */
const KEY = 'ipoteka_guest_key';

function uuid(): string {
    try {
        if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
            return crypto.randomUUID();
        }
    } catch {
        /* secure-context недоступен — уходим в fallback */
    }
    return 'gxxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

export function getGuestKey(): string {
    try {
        let k = localStorage.getItem(KEY);
        if (!k) {
            k = uuid();
            localStorage.setItem(KEY, k);
        }
        return k;
    } catch {
        // localStorage недоступен (приватный режим и т.п.) — эфемерный ключ на запрос.
        return uuid();
    }
}
